import { isNumberLike } from './isNumberLike.js';

function toNumber(v, d) {
  const dd = arguments.length === 1 ? NaN : d;
  const vv = isNumberLike(v) ? Number(v) : dd;
  return Number.isNaN(vv) ? dd : vv;
}

export { toNumber };
//# sourceMappingURL=toNumber.js.map
//# sourceMappingURL=toNumber.js.map